import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { CrawfordSnackbarService, CrawfordSpinnerService, ITabComponent,
  CrawfordGridComponent, GridColumn, DateFormat } from 'crawford-shell';

import { global } from '../../app.settings';

import { ClaimService } from '../claim.service';
import { ClaimParty } from '../model/claim-party.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-claim-parties',
  templateUrl: './claim-parties.component.html',
  styleUrls: ['./claim-parties.component.scss']
})
export class ClaimPartiesComponent implements OnInit, ITabComponent {

  @Input() public crawfordRef: string;
  @Input() public source: string;
  @ViewChild('ccogrid') public ccoGrid: CrawfordGridComponent;


  public gridData: ClaimParty[];
  dataLoaded = false;

  displayColumns: GridColumn[] = [
    new GridColumn('type', 'Type'),
    new GridColumn('name', 'Name'),
    new GridColumn('reference', 'Reference'),
    new GridColumn('contactNumber', 'Contact Number'),
    new GridColumn('address', 'Address'),
    new GridColumn('postcode', 'Postcode'),
  ];

  constructor(
    private claimService: ClaimService,
    private snackbarService: CrawfordSnackbarService,
    private spinnerService: CrawfordSpinnerService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
  }

  loadData(): void {
    if (!this.dataLoaded) {
      this.spinnerService.show('claimPartiesSpinner');
      this.createGridData();
    }
  }

  createGridData() {
    this.claimService.getClaimParties(this.crawfordRef, this.source).subscribe(
      claimParties => {
        if (claimParties) {
          this.gridData = claimParties;
          this.dataLoaded = true;
        } else {
          this.snackbarService.displayErrorMessage('No Parties were found for Claim: ' + this.crawfordRef);
        }
      this.spinnerService.hide('claimPartiesSpinner');
      },
      error => {
        this.spinnerService.hide('claimPartiesSpinner');
      }
    );
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-parties/claim-parties.component.ts